import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';
import { ModalAjudaAtivacaoKriptonitaComponent } from '../modal-ajuda-ativacao-kriptonita/modal-ajuda-ativacao-kriptonita.component';

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.css']
})
export class GenericModalComponent implements OnInit {


  ngOnInit() {}
  onNoClick(): void {
    this.dialogRef.close();
    const action = this.data.action;
   if (action) {
      window.open(action);
    }
  }

  onYesClick(): void {
    this.dialogRef.close('download');
    this.document.location.href = this.data.action;
  }

  existsHelp(): boolean {
    return this.data.help;
   // return false;
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public dialogRef: MatDialogRef<GenericModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {}


  openDialogHelp() {
    const titulo = 'Passos para ativar as extensões do Kriptonita no Chrome';
    this.dialog.open(ModalAjudaAtivacaoKriptonitaComponent, {data: {titulo}});
  }

  get txtMensagem(): String {    
    return this.data.mensagem ;
  }

  get mostraBtnConfirma() :boolean{
    return this.data.labelconfirmar !== undefined;
  }
}